import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const Style = makeStyles((theme: Theme) =>
  createStyles({
    stockMain: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      overflow: "hidden",
      bottom: "0",
      minHeight: "92vh !important",
      marginBottom: "0 !important",
      paddingBottom: "30px",
    },
    headerText: {
      color: theme.customColors.title,
      fontSize: "20px",
    },
    stockHdr: {
      color: "#000",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
      width: "fit-content",
      borderBottom: "2px solid #000",
      paddingBottom: "8px",
    },
    back: {
      color: theme.customColors.title,
      borderRadius: "10px",
      cursor: "pointer",
    },
    backBtn: {
      marginTop: "auto",
      marginBottom: "auto",
      width: "auto",
      cursor: "pointer",
    },
    cart: {
      boxShadow: "rgba(0, 0, 0, 0.24) -2px 0px 6px",
      width: "99%",
      margin: "auto",
    },
    title: {
      color: theme.customColors.title,
      fontSize: "18px",
      textAlign: "center",
    },
    puchsBtn: {
      gap: "8px",
      display: "flex",
      cursor: "pointer",
      justifyContent: "flex-end",
      fontWeight: 600,
    },
    purchsCnt: {
      fontWeight: 600,
      fontSize: "17px",
      padding: "0 40px 0",
      textAlign: "center",
    },
    icons: {
      color: theme.customColors.main,
      width: "auto",
      marginTop: "auto",
      marginBottom: "auto",
      cursor: "pointer",
      "& .MuiSvgIcon-root": {
        fontSize: "40px",
        padding: "5px",
      },
    },
    "@media (max-width: 768px)": {
      stockMain: {
        marginLeft: "6px",
      },
    },
  })
);
